import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'data-table',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    thead: {
      '& $cell': {
        ...theme.typography.h5,
        padding: theme.spacing(1, 1.5),
      },
    },
    tbody: {
      '& $cell': {
        minHeight: 62,
        padding: theme.spacing(1.5),
      },
    },
    row: {},
    expandableRow: {},
    cell: {
      border: 'none',
      flexGrow: 1,
    },
  }),
  options
);

export default useStyles;
